import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SupplementaryEquipmentTakeBackComponent } from './component/supplementary-equipment-take-back.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonLayoutModule, CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { MaterialModule, ServiceResponseModule, TransportInfoPanelModule } from '@sdbn/appclient';

@NgModule({
  declarations: [SupplementaryEquipmentTakeBackComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    TransportInfoPanelModule,
    CommonUIModule,
    CommonLayoutModule,
    CommonTranslationModule,
    ServiceResponseModule
  ],
  exports: [SupplementaryEquipmentTakeBackComponent]
})
export class SupplementaryEquipmentTakeBackModule { }
